export * from './DeprecatedInput';
export * from './DeprecatedInput.types';
export { getColorVariants as getInputColorVariants } from './utils';
